<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Price.AirCargoRateDetails')"
    :width="dialogWidth"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view air-form"
  >
    <div class="main-content">
      <div style="margin-bottom: 10px">
        <el-button no="onSubmit" type="primary" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
      <div style="width: fit-content">
        <div style="display: flex">
          <div class="section form-column">
            <el-form
              label-width="75px"
              label-position="left"
            >
              <el-form-item :label="$t('Pricing.Level')">
                <el-select
                  v-model="airLevel"
                  no="airLevel"
                  :disabled="!isNew"
                >
                  <el-option
                    v-for="(item,index) in tiers"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item ref="pol" required :label="$t('Pricing.Origin')">
                <cargo-advance-select
                  no="pol"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :default-value="priceAir.pol"
                  filterable
                  @parentCallBack="p=>{priceAir.pol=p.code}"
                />
              </el-form-item>
              <el-form-item ref="pod" required :label="$t('Pricing.Dest')">
                <cargo-advance-select
                  no="pod"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="priceAir.pod"
                  filterable
                  @parentCallBack="p=>{priceAir.pod=p.code}"
                />
              </el-form-item>
              <el-form-item label=" ">
                <el-checkbox v-model="isDirect" no="isDirect" :label="$t('Pricing.Direct')" />
              </el-form-item>
              <el-form-item v-if="!isDirect" ref="via" :required="true" :label="$t('Pricing.TSport')">
                <cargo-advance-select
                  no="via"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="priceAir.via"
                  filterable
                  @parentCallBack="p=>{priceAir.via=p.code}"
                />
              </el-form-item>
              <el-form-item v-if="!isDirect" :label="$t('Price.SecondTransit')">
                <cargo-advance-select
                  no="via2"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="priceAir.via2"
                  filterable
                  @parentCallBack="p=>{priceAir.via2=p.code}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Flight')">
                <el-tooltip class="item" effect="dark" :content="serviceItem.toString()" placement="top-end">
                  <cargo-advance-select
                    no="flight"
                    filterable
                    multiple
                    :select-type="selectTypeNames.basic_data_PriceServiceAir"
                    :custom-label="(item)=>`[${item.code}]${item.chineseName}`"
                    :show-custom-label-in-option="true"
                    :default-multiple-value="serviceItem"
                    @parentCallBack="p=>{serviceItem=p.value}"
                  />
                </el-tooltip>
              </el-form-item>

              <el-form-item ref="flightNo" :label="$t('Pricing.FlightNo')">
                <!-- <cargo-advance-select
                  no="flightNo"
                  filterable
                  multiple
                  :select-type="selectTypeNames.basic_data_FlightNo"
                  tag-name="flightNo"
                  tag-value="uuid"
                  :show-custom-label-in-option="true"
                  :default-multiple-value="priceAir.flightNo"
                  @parentCallBack="p=>{priceAir.flightNo=p.value}"
                /> -->
                <cargo-advance-select
                  no="flightNo"
                  filterable
                  multiple
                  tag-name="flightNo"
                  tag-value="uuid"
                  :static-options="flightNoOption"
                  :filter-tag-names="['flightNo']"
                  :show-custom-label-in-option="true"
                  :default-multiple-value="priceAir.flightNoUuid"
                  @parentCallBack="p=>{priceAir.flightNoUuid=p.value}"
                />
              </el-form-item>
              <el-form-item ref="aircraft" required :label="$t('Pricing.Aircraft')">
                <el-input
                  v-model="aircraft"
                  no="aircraft"
                  :maxlength="64"
                />
              </el-form-item>
              <el-form-item :label="$t('Price.SecondLegAircraftType')">
                <el-input
                  v-model="secondAircraft"
                  no="secondAircraft"
                  :maxlength="64"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Currency')">
                <cargo-advance-select
                  no="currency"
                  :select-type="selectTypeNames.basic_data_Currency"
                  filterable
                  :clearable="false"
                  :default-value="priceAir.currency"
                  @parentCallBack="p=>{priceAir.currency=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.weightVolume')">
                <cargo-advance-select
                  no="weightVolume"
                  :select-type="selectTypeNames.local_cache_PriceConstant$WEIGHT_VOLUMES"
                  filterable
                  :clearable="true"
                  :default-value="priceAir.weightVolume"
                  @parentCallBack="p=>{priceAir.weightVolume=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.priceNature')">
                <cargo-advance-select
                  no="priceNature"
                  :select-type="selectTypeNames.local_cache_PriceConstant$PRICE_NATURE"
                  :show-custom-label-in-option="true"
                  :default-value="priceAir.priceNature"
                  @parentCallBack="p=>{priceAir.priceNature=p.value}"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form
              label-width="75px"
              label-position="left"
            >
              <el-form-item :label="$t('Pricing.MinCharge')">
                <price-air-numeric-stepper
                  v-model="priceAir.minCharge"
                  no="minCharge"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.NStep')">
                <price-air-numeric-stepper
                  v-model="priceAir.step"
                  no="step"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="+45">
                <price-air-numeric-stepper
                  v-model="priceAir.p45"
                  no="p45"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="+100">
                <price-air-numeric-stepper
                  v-model="priceAir.p100"
                  no="p100"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="+300">
                <price-air-numeric-stepper
                  v-model="priceAir.p300"
                  no="p300"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="+500">
                <price-air-numeric-stepper
                  v-model="priceAir.p500"
                  no="p500"
                />
              </el-form-item>
              <el-form-item label="+1000">
                <price-air-numeric-stepper
                  v-model="priceAir.p1000"
                  no="p1000"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form
              label-width="90px"
              label-position="left"
            >
              <el-form-item ref="carrier" required :label="$t('Pricing.Carrier_Air')">
                <cargo-advance-select
                  no="carrier"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{airCmp:true}"
                  :default-value="priceAir.carrier"
                  @parentCallBack="p=>{priceAir.carrier=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item ref="bookingAgent" required :label="$t('Pricing.Agent')">
                <cargo-advance-select
                  no="bookingAgent"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{bookingAgent:true}"
                  tag-name="chineseName"
                  :default-value="priceAir.bookingAgent"
                  @parentCallBack="p=>{priceAir.bookingAgent=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item ref="isFrequency" required :label="$t('Pricing.DepartureDayOfAir')">
                <el-input
                  no="isFrequency"
                  :disabled="true"
                  :value="isFrequency"
                />
              </el-form-item>
              <div class="frequency">
                <el-checkbox v-model="priceAir.frequency1" no="frequency1" :label="1" />
                <el-checkbox v-model="priceAir.frequency2" no="frequency2" :label="2" />
                <el-checkbox v-model="priceAir.frequency3" no="frequency3" :label="3" />
                <el-checkbox v-model="priceAir.frequency4" no="frequency4" :label="4" />
                <el-checkbox v-model="priceAir.frequency5" no="frequency5" :label="5" />
                <el-checkbox v-model="priceAir.frequency6" no="frequency6" :label="6" />
                <el-checkbox v-model="priceAir.frequency7" no="frequency7" :label="7" />
              </div>

              <el-form-item :label="$t('Price.SecondLegFlightSchedule')">
                <el-input
                  :disabled="true"
                  :value="isFrequency2"
                />
              </el-form-item>
              <div class="frequency">
                <el-checkbox v-model="priceAir.secondFrequency1" no="secondFrequency1" :label="1" />
                <el-checkbox v-model="priceAir.secondFrequency2" no="secondFrequency2" :label="2" />
                <el-checkbox v-model="priceAir.secondFrequency3" no="secondFrequency3" :label="3" />
                <el-checkbox v-model="priceAir.secondFrequency4" no="secondFrequency4" :label="4" />
                <el-checkbox v-model="priceAir.secondFrequency5" no="secondFrequency5" :label="5" />
                <el-checkbox v-model="priceAir.secondFrequency6" no="secondFrequency6" :label="6" />
                <el-checkbox v-model="priceAir.secondFrequency7" no="secondFrequency7" :label="7" />
              </div>
              <el-form-item ref="days" required :label="$t('Pricing.Days')">
                <el-input
                  v-model="priceAir.days"
                  no="days"
                  :maxlength="16"
                />
              </el-form-item>
              <el-form-item ref="beginDate" required :label="$t('Pricing.BeginDate')">
                <div style="display: flex;">
                  <el-date-picker
                    v-model="priceAir.beginDate"
                    no="beginDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item ref="endDate" required :label="$t('Pricing.EndDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="priceAir.endDate"
                    no="endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.Remarks')">
                <cargo-rich-textarea
                  v-model="priceAir.remarks"
                  no="remarks"
                  :text-chars="0"
                  style="min-height: 80px"
                  :warning-count="-1"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),priceAir.remarks,val=>{priceAir.remarks=val})"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form
              v-show="priceAir.level === 0"
              label-width="70px"
              label-position="left"
            >
              <el-form-item label="T1Min">
                <price-air-numeric-stepper
                  v-model="priceAir.t1Min"
                  no="T1Min"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T1Step">
                <price-air-numeric-stepper
                  v-model="priceAir.t1Step"
                  no="T1Step"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T1P45">
                <price-air-numeric-stepper
                  v-model="priceAir.t1P45"
                  no="T1P45"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T1P100">
                <price-air-numeric-stepper
                  v-model="priceAir.t1P100"
                  no="T1P100"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T1P300">
                <price-air-numeric-stepper
                  v-model="priceAir.t1P300"
                  no="T1P300"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T1P500">
                <price-air-numeric-stepper
                  v-model="priceAir.t1P500"
                  no="T1P500"
                />
              </el-form-item>
              <el-form-item label="T1P1000">
                <price-air-numeric-stepper
                  v-model="priceAir.t1P1000"
                  no="T1P1000"
                />
              </el-form-item>
              <el-form-item label="T2Min">
                <price-air-numeric-stepper
                  v-model="priceAir.t2Min"
                  no="T2Min"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T2Step">
                <price-air-numeric-stepper
                  v-model="priceAir.t2Step"
                  no="T2Step"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T2P45">
                <price-air-numeric-stepper
                  v-model="priceAir.t2P45"
                  no="T2P45"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T2P100">
                <price-air-numeric-stepper
                  v-model="priceAir.t2P100"
                  no="T2P100"
                  :show-tact="true"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form
              v-show="priceAir.level === 0"
              label-width="70px"
              label-position="left"
            >
              <el-form-item label="T2P300">
                <price-air-numeric-stepper
                  v-model="priceAir.t2P300"
                  no="t2P300"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T2P500">
                <price-air-numeric-stepper
                  v-model="priceAir.t2P500"
                  no="t2P500"
                />
              </el-form-item>
              <el-form-item label="T2P1000">
                <price-air-numeric-stepper
                  v-model="priceAir.t2P1000"
                  no="T2P1000"
                />
              </el-form-item>
              <el-form-item label="T3Min">
                <price-air-numeric-stepper
                  v-model="priceAir.t3Min"
                  no="t3Min"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T3Step">
                <price-air-numeric-stepper
                  v-model="priceAir.t3Step"
                  no="t3Step"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T3P45">
                <price-air-numeric-stepper
                  v-model="priceAir.t3P45"
                  no="t3P45"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T3P100">
                <price-air-numeric-stepper
                  v-model="priceAir.t3P100"
                  no="t3P100"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T3P300">
                <price-air-numeric-stepper
                  v-model="priceAir.t3P300"
                  no="t3P300"
                  :show-tact="true"
                />
              </el-form-item>
              <el-form-item label="T3P500">
                <price-air-numeric-stepper
                  v-model="priceAir.t3P500"
                  no="t3P500"
                />
              </el-form-item>
              <el-form-item label="T3P1000">
                <price-air-numeric-stepper
                  v-model="priceAir.t3P1000"
                  no="t3P1000"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :required="false"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        style="height: 198px;"
      />
      <span slot="footer">
        <el-button
          no="finishAdvanceText"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { savePriceAir } from '@/api/price/priceAir'
import PriceAirNumericStepper from '@/views/cargo/v0/Price/Quotation/components/PriceAirNumericStepper'
import { queryAllAirFlightNo } from '@/api/price/airFlightInfo'

export default {
  name: 'AirForm',
  components: {
    PriceAirNumericStepper, CargoAgGrid, cargoAdvanceSelect,
    cargoRichTextarea },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    isNew: {
      type: Boolean,
      default: () => false
    },
    priceAir: {
      type: Object,
      default: () => ({})
    },
    isCp: {
      type: Boolean,
      default: () => false
    },
    level: {
      type: String,
      default: () => '0'
    }
  },
  data() {
    return {
      fullscreenLoading: null,
      selectTypeNames: TYPE_NAMES,
      tiers: PriceUtils.getTiers(true, true, 0),
      frequencys: PriceUtils.FREQUENCYS,
      isDirect: false,
      flightNoOption: [],
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0
        }
      },
      isCommit: false // 防止重复提交
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    airLevel: {
      get() {
        return String(this.priceAir.level)
      },
      set(val) {
        this.priceAir.level = parseInt(val)
      }
    },
    aircraft: {
      get() {
        return this.getAircraft('aircraft')
      },
      set(val) {
        this.setAircraft('aircraft', val)
      }
    },
    serviceItem: {
      get() {
        return this.getServiceItem('serviceItem')
      },
      set(val) {
        this.setServiceItem('serviceItem', val)
      }
    },
    secondAircraft: {
      get() {
        return this.getAircraft('secondAircraft')
      },
      set(val) {
        this.setAircraft('secondAircraft', val)
      }
    },
    isFrequency() {
      return this.setFrequency('frequency')
    },
    isFrequency2() {
      return this.setFrequency('secondFrequency')
    },
    isZh() {
      return this.$store.getters.language
    },
    dialogWidth() {
      return this.level === '0' ? '1600px' : '960px'
    }
  },
  mounted() {
    this.isDirect = StrUtils.isEmpty(this.priceAir.via)
    if (this.priceAir.flightNoUuid) {
      this.priceAir.flightNoUuid = this.priceAir.flightNoUuid.split(',')
    }
    this.getFlightNo()
  },
  methods: {
    onSubmit() {
      if (this.isCommit) {
        return
      }
      this.isCommit = true
      if (!this.check()) {
        this.isCommit = false
        return
      }
      this.setTValue('t1Min', 't1Step', 't1P45', 't1P100', 't1P300', 't1P500', 't1P1000',
        't2Min', 't2Step', 't2P45', 't2P100', 't2P300', 't2P500', 't2P1000',
        't3Min', 't3Step', 't3P45', 't3P100', 't3P300', 't3P500', 't3P1000')
      this.priceAir.modifiedBy = this.$store.getters.userId
      if (this.priceAir.flightNoUuid) {
        this.priceAir.flightNoUuid = this.priceAir.flightNoUuid.toString()
      }
      this.priceAir.dateModified = new Date()
      this.priceAir.branchId = this.$store.getters.currentOfficeId
      this.save()
    },
    check() {
      if (this.verifyForm()) {
        return false
      }
      if (this.verifySame('pol', 'pod')) {
        return false
      }
      if (!this.isDirect) {
        if (StrUtils.isEmpty(this.priceAir.via)) {
          const label = this.$t('Pricing.TSport')
          this.$refs['via'].$el.getElementsByTagName('input')[0].focus()
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return false
        }
        if (this.verifySame('via', 'pol')) {
          return false
        }
        if (this.verifySame('via', 'pod')) {
          return false
        }
        if (!StrUtils.isEmpty(this.priceAir.via2)) {
          if (this.verifySame('via2', 'pol')) {
            return false
          }
          if (this.verifySame('via2', 'pod')) {
            return false
          }
        }
      } else {
        this.priceAir.via = ''
        this.priceAir.via2 = ''
      }
      this.priceAir.direct = this.isDirect
      if (!this.priceAir.direct) {
        if (StrUtils.isEmpty(this.isFrequency2)) {
          this.$message.warning(this.$t('Price.SecondScheduleCannotBeEmpty'))
          return false
        }
      }
      if (this.priceAir.beginDate > this.priceAir.endDate) {
        this.$message.warning(this.$t('Pricing.CompareValidate'))
        return false
      }
      return true
    },
    save() {
      let isUpdateState = false
      if (!this.isNew) {
        if (this.priceAir.state === 1) {
          this.priceAir.state = 0
          isUpdateState = true
        }
      }
      this.fullscreenLoading = getLoading()
      console.log('this.priceAir====', this.priceAir)
      savePriceAir(this.priceAir).then((res) => {
        if (isUpdateState) {
          this.$message.success(this.$t('Pricing.CurrentPriceEditSucceed'))
        } else {
          this.$message.success(this.$t('Pricing.SavedSucceed'))
        }
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.fullscreenLoading.close()
        this.isCommit = false
      })
    },
    // 查询航班号
    getFlightNo() {
      queryAllAirFlightNo().then((res) => {
        // if (this.priceAir.flightNo) {
        //   const flightNoArr = this.priceAir.flightNo.split(',')
        //   const newArr = []
        //   if (flightNoArr.length > 0) {
        //     for (const item of res.data) {
        //       if (flightNoArr.includes(item['flightNo'])) {
        //         newArr.push(item.uuid)
        //       }
        //     }
        //   }
        //   this.priceAir.flightNo = newArr
        // }
        this.flightNoOption = res.data
      })
    },
    // 加价幅度
    setTValue(...fields) {
      if (this.priceAir.level !== 0) {
        fields.forEach(item => {
          if (!this.priceAir[item]) {
            this.priceAir[item] = 0
          }
        })
      }
    },
    verifyForm() {
      for (const ref in this.$refs) {
        if (this.$refs[ref].isRequired && this.verifyField(ref)) {
          this.$refs[ref].$el.getElementsByTagName('input')[0].focus()
          if (ref === 'days') {
            this.$message.warning(this.$t('Pricing.DaysValidate'))
            return true
          }
          const label = this.$refs[ref].label
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return true
        }
      }
    },
    verifyField(field) {
      if (field === 'isFrequency') {
        return StrUtils.isEmpty(this.isFrequency)
      }
      if (typeof this.priceAir[field] === 'number') {
        return this.priceAir[field] === 0
      }
      return StrUtils.isEmpty(this.priceAir[field])
    },
    verifySame(field1, field2) {
      if (this.priceAir[field1] === this.priceAir[field2]) {
        const label1 = this.$refs[field1].label
        const label2 = this.$refs[field2].label
        const message = this.$t('Pricing.MustDifferent')
        this.$message.warning(message.replace('{0}', label1).replace('{1}', label2))
        return true
      }
      return false
    },
    onCancel() {
      this.$emit('close')
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    getAircraft(field) {
      const aircraft = this.priceAir[field]
      if (aircraft) {
        switch (aircraft) {
          case 'C':
            return this.$t('Pricing.CargoAircraft')
          case 'A':
            return this.$t('Pricing.Airliner')
          case 'H':
            return this.$t('Pricing.HeadLiftAircraft')
        }
      }
      return aircraft
    },
    setAircraft(field, val) {
      let aircraft = val
      if (val) {
        switch (val) {
          case this.$t('Pricing.CargoAircraft'):
            aircraft = 'C'
            break
          case this.$t('Pricing.Airliner'):
            aircraft = 'A'
            break
          case this.$t('Pricing.HeadLiftAircraft'):
            aircraft = 'H'
            break
        }
      }
      this.priceAir[field] = aircraft
    },
    getServiceItem(field) {
      console.log('this.priceAir[field]', this.priceAir[field])
      if (this.priceAir[field]) {
        return this.priceAir[field].split(',')
      } else {
        return []
      }
    },
    setServiceItem(field, val) {
      this.priceAir[field] = val.toString()
    },
    handleEdit(e) {
      const value = e.replace(/\D/g, '') // 以0开头或者输入非数字，会被替换成空
      if (value) {
        this.priceAir.weightVolume = Number(value)
      }
    },
    setFrequency(targetField) {
      const FREQUENCYS = PriceUtils.FREQUENCYS
      const arr = []
      for (const field of FREQUENCYS) {
        if (this.priceAir[targetField + field]) {
          arr.push(field)
        }
      }
      return arr.join('/')
    }
  }
}
</script>

<style lang="scss">
  .air-form{
    .el-radio{
      margin-right: 20px;
    }
    .frequency{
      display: flex;
      .el-checkbox{
        margin-right: 12px;
      }
    }
  }
</style>
